<template>
    <div v-for="bericht in getClosestDate()" :style="'background: linear-gradient(90deg, ' + bericht.banner.left_color + ' 45%, ' + bericht.banner.right_color + ' 100%)'">
        <Teleport to="body">
            <Popup :overflowHidden="true" :open="marketingModalOpen" @open="closeAction" class="px-6">
                <div @click="marketingPopupClick()" class="cursor-pointer">
                    <img :alt="bericht.popup.alt" class="block w-full h-full" :src="route.name === 'dashboard-home' ? bericht.popupDashboard.url : bericht.popup.url" />
                </div>
            </Popup>
        </Teleport>

        <div class="flex flex-col lg:flex-row gap-2 lg:gap-0 justify-center w-full items-center">
            <div v-if="bericht.banner.left_text" class="flex-row w-full lg:w-1/2 bannerContent">
                <router-link :to="isLoggedIn ? bericht.banner.left_url : bericht.banner.left_url_alt">
                    <p class="text-center uppercase text-white text-xs xl:text-base text-center bannerText font-semibold">{{ bericht.banner.left_text }}</p>
                </router-link>
            </div>
            <div v-if="bericht.banner.middle_text" class="flex-row w-full lg:w-1/2 bannerContent">
                <router-link :to="isLoggedIn ? bericht.banner.middle_url : bericht.banner.right_url_alt">
                    <p class="text-center uppercase text-white text-xs xl:text-base text-center bannerText font-semibold" v-html="bericht.banner.middle_text"></p>
                </router-link>
            </div>
            <div v-if="bericht.banner.right_text" class="flex-row w-full lg:w-1/2 bannerContent">
                <router-link :to="isLoggedIn ? bericht.banner.right_url : bericht.banner.right_url_alt">
                    <p class="text-center uppercase text-white text-xs xl:text-base text-center bannerText font-semibold">{{ bericht.banner.right_text }}</p>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script setup>
import { asset } from '../helpers';
import { store } from '../store';
import router from '../router';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

let marketingModalOpen = ref(false);
const sonderBerichte = [
    {
        start: '2024-01-07 00:00:00',
        end: '2024-01-13 23:59:59',
        banner: {
            left_text: 'Sonderbericht China',
            left_color: 'rgb(195 60 46 / 49)',
            left_url: '/dashboard/contentstreams/0643c1f6-3cf6-418b-8a4b-470d4675232b',
            left_url_alt: '/produkte/china-titans',
            right_text: 'Sonderbericht Industriemetalle',
            right_color: 'rgb(105 116 137)',
            right_url: '/dashboard/contentstreams/6155e295-fcaa-4577-8d30-1a6021f5bdc2?active_tab=special&page=1&type=contentstreams',
            right_url_alt: '/produkte/industriemetalle-paket'
        },
        popup: {
            url: asset('hkcm/images/banner/SOC_Banner_Sonderberichte_China_Industrie_2024.png', 'public'),
            alt: 'Banner_Sonderberichte_China_Industrie_2024'
        },
        popupDashboard: {
            url: asset('hkcm/images/banner/MKT_Sonderberichte_2024_Ueberischtsgrafik.png', 'public'),
            alt: 'Sonderberichte 2024 Überischtsgrafik'
        }
    },
    {
        start: '2024-01-14 00:00:00',
        end: '2024-01-20 23:59:59',
        banner: {
            left_text: 'Sonderbericht USA',
            left_color: 'rgb(108, 150, 220)',
            left_url: '/dashboard/contentstreams/3e0246eb-7816-4b00-97e7-4ada3f17750c?active_tab=special&page=1&type=contentstreams',
            left_url_alt: 'Us-Titans',
            right_text: 'Sonderbericht Cannabis',
            right_color: 'rgb(17 179 70)',
            right_url: '/dashboard/contentstreams/ef2c0abc-71b1-4748-97bd-753cd9253cc9?active_tab=special&page=1&type=contentstreams',
            right_url_alt: 'Cannabis-Aktien'
        },
        popup: {
            url: asset('hkcm/images/banner/SOC_Banner_Sonderberichte_USA_Cannabis_2024.png', 'public'),
            alt: ''
        },
        popupDashboard: {
            url: asset('hkcm/images/banner/MKT_Sonderberichte_2024_Ueberischtsgrafik.png', 'public'),
            alt: 'Sonderberichte 2024 Überischtsgrafik'
        }
    },
    {
        start: '2024-01-21 00:00:00',
        end: '2024-01-27 23:59:59',
        banner: {
            left_text: 'Sonderbericht Deutschland',
            left_color: 'rgb(0 0 0)',
            left_url: '/dashboard/contentstreams?active_tab=special&page=1',
            left_url_alt: '/produkte/dax40-aktien',
            right_text: 'Sonderbericht Agrarprodukte',
            right_color: 'rgb(216 198 107)',
            right_url: '/dashboard/contentstreams?active_tab=special&page=1',
            right_url_alt: '/produkte/agrar-paket'
        },
        popup: {
            url: asset('hkcm/images/banner/SOC_Banner_Sonderberichte_Deutschland_Agrarprodukte_2024.png', 'public'),
            alt: ''
        },
        popupDashboard: {
            url: asset('hkcm/images/banner/MKT_Sonderberichte_2024_Ueberischtsgrafik.png', 'public'),
            alt: 'Sonderberichte 2024 Überischtsgrafik'
        }
    },
    {
        start: '2024-01-28 00:00:00',
        end: '2024-02-01 23:59:59',
        banner: {
            left_text: 'Sonderbericht Edelmetalle',
            left_color: 'rgb(108 89 10)',
            left_url: '/dashboard/contentstreams?active_tab=special&page=1',
            left_url_alt: '/produkte/gold',
            right_text: 'Sonderbericht Energie',
            right_color: 'rgb(170 157 163)',
            right_url: '/dashboard/contentstreams?active_tab=special&page=1',
            right_url_alt: '/produkte/rohoel',
            middle_text: '',
            middle_color: '',
            middle_url: '',
            middle_url_alt: ''
        },
        popup: {
            url: asset('hkcm/images/banner/SOC_Banner_Sonderberichte_Edelmetalle_Energie.png', 'public'),
            alt: 'Sonderbericht Edalmetalle+Energie'
        },
        popupDashboard: {
            url: asset('hkcm/images/banner/MKT_Sonderberichte_2024_Ueberischtsgrafik.png', 'public'),
            alt: 'Sonderberichte 2024 Überischtsgrafik'
        }
    },
    {
        start: '2024-02-02 00:00:00',
        end: '2024-02-03 23:59:59',
        banner: {
            left_text: '',
            left_color: 'rgb(3 19 42)',
            left_url: '',
            left_url_alt: '',
            right_text: '',
            right_color: 'rgb(253 234 0)',
            right_url: '',
            right_url_alt: '',
            middle_text: 'Jetzt 20% Rabatt auf alle Produkte! <br> Code: HKCM400',
            middle_color: '',
            middle_url: '/produkte',
            middle_url_alt: '/produkte'
        },
        popup: {
            url: asset('hkcm/images/banner/SOC_Banner400kAktion.png', 'public'),
            alt: '400k Aktion'
        },
        popupDashboard: {
            url: asset('hkcm/images/banner/SOC_Banner_Sonderberichte_Edelmetalle_Energie.png', 'public'),
            alt: 'Sonderberichte Edalmetalle und Energie'
        }
    },
    {
        start: '2024-02-04 00:00:00',
        end: '2024-02-12 23:59:59',
        banner: {
            left_text: '',
            left_color: 'rgb(3 19 42)',
            left_url: '',
            left_url_alt: '',
            right_text: '',
            right_color: 'rgb(253 234 0)',
            right_url: '',
            right_url_alt: '',
            middle_text: 'Jetzt 20% Rabatt auf alle Produkte! <br> Code: HKCM400',
            middle_color: '',
            middle_url: '/produkte',
            middle_url_alt: '/produkte'
        },
        popup: {
            url: asset('hkcm/images/banner/SOC_Banner400kAktion.png', 'public'),
            alt: '400k Aktion'
        },
        popupDashboard: {
            url: asset('hkcm/images/banner/Technologie_Krypto.png', 'public'),
            alt: 'Sonderberichte 2024 Technologie und Krypto'
        }
    }
];
let isLoggedIn = store.getters['user/isLoggedIn'];
const currentPagePath = router.currentRoute.value.fullPath;
const route = useRoute();
let hasLoggedIn = false;

const getClosestDate = () => {
    let today = new Date().getTime();
    let sortedBerichte = [];

    for (const bericht of sonderBerichte) {
        if (today < new Date(bericht.end).getTime() && today > new Date(bericht.start).getTime()) {
            sortedBerichte.push(bericht);
        }
    }

    return sortedBerichte.sort(function (a, b) {
        return new Date(a.start) - new Date(b.start);
    });
};

const closeAction = () => {
    marketingModalOpen.value = false;
};

const marketingPopupClick = () => {
    marketingModalOpen.value = false;

    if (isLoggedIn) {
        router.push('/dashboard/contentstreams?active_tab=special&page=1'),
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
    } else {
        router.push('/produkte');
    }
};

watch(
    () => route.name,
    () => {
        isLoggedIn = store.getters['user/isLoggedIn'];

        if (isLoggedIn && route.name === 'dashboard-home' && !hasLoggedIn) {
            hasLoggedIn = true;
            marketingModalOpen.value = true;
        }
    }
);

setTimeout(() => {
    if (currentPagePath === '/' || currentPagePath === '/dashboard') {
        marketingModalOpen.value = true;
    }
}, 3000);
</script>

<style scoped>
.bannerContent p {
    letter-spacing: 5px;
    word-spacing: 10px;
}
.bannerContent {
    animation: pulse 10s infinite;
}
@keyframes pulse {
    0% {
        transform: scale(0.93);
    }

    50% {
        transform: scale(1);
    }

    100% {
        transform: scale(0.93);
    }
}
</style>
